import { ClearIcon } from '@app/components/icons/clear';
import { SearchIcon } from '@app/components/icons/search';
import { Spinner } from '@app/components/icons/spinner';
import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React, { ChangeEvent } from 'react';

export const SearchBox = ({
  value,
  onChange,
  onClear,
  isSearching,
}: {
  value: string;
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  isSearching: boolean;
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'content-recording.search-box',
  });

  return (
    <div className="px-4 py-3">
      <div className="relative w-full">
        <label
          htmlFor="search-field"
          className={cx(
            'absolute top-1/2 -translate-y-1/2 left-2 cursor-pointer m-0',
            { 'pointer-events-none cursor-not-allowed': isSearching },
          )}
        >
          <span className="sr-only">
            {isSearching ? t('searching') : t('search')}
          </span>

          {isSearching ? (
            <Spinner size="tiny" />
          ) : (
            <SearchIcon className="w-4 h-4" />
          )}
        </label>

        <input
          id="search-field"
          type="text"
          value={value}
          placeholder={t('placeholder')}
          aria-label={t('aria-label')}
          onChange={onChange}
          autoComplete="off"
          className={cx(
            'pl-7 pr-2.5 py-1.5 h-8 border border-gray-700 placeholder:text-spring-neutral-b3 text-white rounded-10 bg-gray-850',
            'text-sm font-normal',
            {
              'pr-9': Boolean(value),
            },
          )}
        />

        {value && (
          <button
            type="button"
            className={cx(
              'absolute top-1/2 -translate-y-1/2 right-1 rounded-md',
              'hover:bg-gray-700 p-1',
              'outline-none focus-visible:outline-none ui-focus-visible:ring-2 ui-focus-visible:ring-blue-500 ui-focus-visible:ring-offset-2 ui-focus-visible:ring-offset-spring-neutral-base',
            )}
            onClick={onClear}
            title={t('clear-search')}
          >
            <span className="sr-only">{t('clear-search')}</span>
            <ClearIcon className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};
